module.exports = __webpack_public_path__ + "static/media/Logo_Rittner_Horn_CMYK.f5febca8.svg";